import type { ModuleDefinition } from '../../app/moduleRegistry';
import { cmsSiteModule } from './site';
import { cmsContentModule } from './content';

/**
 * Top-level CMS/B2C module — combines the two independently-built sibling aggregators
 * (`cms/site`: Site/Header/SiteTitle/Slider/Contact/About/Contract, `cms/content`:
 * City/PopulerCity/CheapestDestination/Destination/Campaign, both already gated behind
 * `isMasterGsa && isFeatureEnabled('HasCmsB2C')` and grouped under `'B2C Yönetimi'` with
 * their own group icon on each aggregator's first item). Simple concatenation — both
 * sub-modules already carry their final labels/icons/groups, no further transformation
 * needed here, matching how `app/modules.ts` itself just concatenates module arrays.
 */
export const cmsModule: ModuleDefinition = {
  routes: [...cmsSiteModule.routes, ...cmsContentModule.routes],
  menuItems: [...cmsSiteModule.menuItems, ...cmsContentModule.menuItems],
};
